import * as React from "react";

export const usePrevious = <P>(value: P): P | undefined => {
	const ref = React.useRef<P>();
	React.useEffect(() => {
		ref.current = value;
	});

	return ref.current;
};
